import { apiClient } from "../config";

async function getAllMarkerGroups(queryParams: any) {
  const res = await apiClient.get(`/admin/marker-groups`, {
    params: queryParams,
  })
  return res.data;
}

export default getAllMarkerGroups;
